<template>
  <div v-if="supplier" class="forms-elements">
    <Breadcrumbs v-bind:breadcrumbs="breadcrumbs" />

    <Widget v-if="supplier">
      <b-row>
        <b-col lg="6" md="6" sm="12">
          <legend>
            <strong>Basisdaten</strong>
          </legend>

          <b-form-group
            horizontal
            :label="$t('supplier')"
            label-for="name"
            label-class="text-md-right"
            :label-cols="4"
            breakpoint="md"
          >
            <b-form-input v-model="supplier.name" type="text" :placeholder="$t('supplier')" />
          </b-form-group>
        </b-col>
      </b-row>

      <!-- Info Section for non-editable fields -->
      <b-row v-if="!isNew">
        <b-col lg="6" md="6" sm="12">
          <hr />
          <b-form-group
            horizontal
            :label="$t('number')"
            label-for="number"
            label-class="text-md-right"
            :label-cols="4"
            breakpoint="md"
            class="mb-0"
          >
            <div class="form-control-plaintext">
              {{ supplier.number.toString().padStart(4, '0') }}
            </div>
          </b-form-group>

          <b-form-group
            horizontal
            :label="$t('createdAt')"
            label-for="createdAt"
            label-class="text-md-right"
            :label-cols="4"
            breakpoint="md"
            class="mb-0"
          >
            <div class="form-control-plaintext">
              {{ formattedCreatedAt }}
            </div>
          </b-form-group>

          <b-form-group
            horizontal
            :label="$t('updatedAt')"
            label-for="updatedAt"
            label-class="text-md-right"
            :label-cols="4"
            breakpoint="md"
            class="mb-0"
          >
            <div class="form-control-plaintext">
              {{ formattedUpdatedAt }}
            </div>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="12" md="12" sm="12">
          <ButtonBar
            :showDeleteButton="buttons.showDeleteButton"
            :isReadOnly="isReadOnly"
            :model="supplier"
            modelEditRoute="SupplierEditPage"
            modelListRoute="SuppliersPage"
            modelRouteParamName="supplierNumber"
            :updateCallback="updateSupplier"
            :createCallback="createSupplier"
            :deleteCallback="deleteSupplier"
            :fetchCallback="fetchSuppliers"
          />
        </b-col>
      </b-row>
    </Widget>
  </div>
</template>

<script>
import Widget from '@/components/Widget/Widget';
import Breadcrumbs from '@/components/Breadcrumbs';
import { mapGetters, mapActions } from 'vuex';
import ButtonBar from '@/components/ButtonBar.vue';
import dayjs from 'dayjs';
import { coversAccessLevel } from '@/helpers/accessLevel';
import { SUPPLIERS_ACCESS_NODE } from '@/navigation/accessNodes';

export default {
  name: 'SupplierEditPage',
  components: {
    Widget,
    Breadcrumbs,
    ButtonBar,
  },
  props: {
    supplierNumber: {
      required: false,
      default: null,
    },
  },
  data() {
    return {
      number: null,
      buttonsDisabled: false,
    };
  },
  computed: {
    ...mapGetters(['getSupplier', 'getSupplierByNumber', 'getAccessLevel']),
    /** Viewer opens the page, but cannot save or delete (fields stay editable for now). */
    isReadOnly() {
      return !coversAccessLevel(this.getAccessLevel(SUPPLIERS_ACCESS_NODE), 'editor');
    },
    buttons() {
      return {
        showDeleteButton: this.supplier && this.supplier.number !== '_new' ? true : false,
      };
    },
    supplier() {
      return this.getSupplierByNumber(this.number);
    },
    isNew() {
      return this.supplier.number === '_new';
    },
    breadcrumbs() {
      return [
        { name: 'Home', route: { name: 'home' } },
        { name: this.$t('all_suppliers'), route: { name: 'SuppliersPage' } },
        {
          name:
            this.supplier.number !== '_new' ? this.$t('supplier_edit') : this.$t('supplier_create'),
        },
      ];
    },
    formattedCreatedAt() {
      if (!this.supplier.createdAt) return '-';
      return dayjs(this.supplier.createdAt).format('DD.MM.YYYY HH:mm');
    },
    formattedUpdatedAt() {
      if (!this.supplier.updatedAt) return '-';
      return dayjs(this.supplier.updatedAt).format('DD.MM.YYYY HH:mm');
    },
  },
  methods: {
    ...mapActions([
      'initSupplier',
      'fetchSuppliers',
      'fetchSupplierByNumber',
      'updateSupplier',
      'createSupplier',
      'deleteSupplier',
    ]),
  },
  async mounted() {
    if (!this.supplier && this.supplierNumber) {
      this.number = this.supplierNumber;
      await this.fetchSupplierByNumber(this.number);
    } else {
      this.initSupplier();
      this.number = '_new';
    }
  },
};
</script>

<style scoped lang="scss">
legend {
  position: relative;
}
</style>
